<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-multimedia" :title="$t('MEMBER.ATTRIBUTES')" :expanded="false">
      <div v-if="groups">
        
        <m-row class="mt-4" v-for="group in groups" :key="group.group_id">
          <m-col lg="12">
            
            <MemberSectionAttributesRow 
              :key="group.group_id"
              :group="group"
            />

            <hr />
          </m-col>
        </m-row>
        
      </div>
    </CollapsibleListItem>
    
  </div>

</template>

<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { is_mobile } from '@/core/services/utils';
import MemberSectionAttributesRow from '@/view/pages/members/loggedin/new_member_profile/MemberSectionAttributesRow.vue';
import CollapsibleListItem from './CollapsibleListItem.vue';

export default {

  name: 'MemberSectionAttributes',

  props: ['member','company','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    MemberSectionAttributesRow,
    CollapsibleListItem
  },

  watch: {
    groups: {
      handler(newVal) {
        newVal.forEach((group) => {
          this.$watch(
            () => group.selectedPropId,
            (newPropId) => {
              this.onPropertyChange(group);
            }
          );
        });
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {
    async save_data() {

      this.$emit('save_data', this.member);

    },

    onPropertyChange(group) {
      console.log(
        `Group ${group.name} selected property ID: ${group.selectedPropId}`
      );
      // You can perform additional actions here
    },

    async fetch_profile_attributes() {
      try {
        const res = await axios.get(`/property_group/profile`);

        if (res.status === 200) {
          this.groups = res.data;
        }
      }
      catch (err) {
        console.error('fetch_profile_attributes', err);
      }
    }

  },

  async mounted() {
    this.show_form = this.expanded;

    await this.fetch_profile_attributes();
  },

  data() {
    return {

      show_form: true,

      groups: []

    };
  }
};

</script>

<style lang="scss" scoped>
  
  

</style>
